import React from "react";
import "components/reusable/ContactInfo/ContactInfo.scss";
import { convertHtmlToReact } from "@hedgedoc/html-to-react/dist/convertHtmlToReact";
import { WagtailImage } from "components/Wagtail/WagtailImage";
import Button from "components/reusable/Button/Button";
import { toggleModal } from "store/reducers/modal/modalSlice";
import { useDispatch } from "react-redux";
import AddressModal from "components/Modals/Address/Address";
import {useLocation} from "react-router-dom";

const Badge = ({ image, title, body, button }) => {
  const dispatch = useDispatch();
  const region = useLocation().pathname.split("/")[2]

  const handleButtonText = (button) => {
    if (button.text === "{phone}") {
      if (region === "van") {
        return "604-532-1555"
      } else if (region === "mtl") {
        return "514-532-1555"
      } else {
        return "416-532-1555"
      }
    } else if (button.text !== "{phone}" && button.url) {
      return convertHtmlToReact(button.url);
    } else {
      return button.text;
    }
  }

  const handleClick = (button) => {
    if (button.url && button.url.includes("{phone}")) {
      const url = "tel:" + handleButtonText(button)
      window.location.href = url;
    } else if (button.url) {
      window.location.href = button.url;
    } else {
      dispatch(toggleModal({
        children: <AddressModal />
      }));
    }
  };

  const handleKeyDown = (button, e) => {
    if (e.key === "Enter") {
      if (button.url) {
        window.location.href = button.url;
      } else {
        dispatch(toggleModal({
          children: <AddressModal />
        }));
      }
    }
  };

  return (
    <div className="homepage-contact-item">
      <WagtailImage height={115} image={image} />
      <h4 tabIndex="0">{title}</h4>
      {body && (
        <div tabIndex="0">{convertHtmlToReact(body)}</div>
      )}
      {button.text && (
        <Button
          btnStyle={"beanfield-button--hollow"}
          style={{
            borderColor: "#325a32",
            fontWeight: 700,
            color: "#325a32",
          }}
          click={() => handleClick(button)}
          onKeyDown={(e) => handleKeyDown(button, e)}
        >
          {handleButtonText(button)}
        </Button>
      )}
    </div>
  );
};

const ContactInfo = ({ title, description, badges }) => {
  return (
    <div className="resi-container">
      <div className="resi-margin-container">
        <div className="homepage-contact-container">
          {title ? <h3 tabIndex="0">{title}</h3> : null}
          {description ? <p tabIndex="0">{description}</p> : null}

          <div className="homepage-contact">
            {badges?.length > 0 &&
            badges.map((badge, index) => {
              return (
                <Badge
                  image={badge.image}
                  title={badge.title}
                  body={badge.description}
                  button={{
                    text: badge.button_txt,
                    url: badge.button_url,
                  }}
                  key={index}
                />
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactInfo;
